import React, { useContext, useMemo } from "react";
import { UnitPreferencesContext } from "../../shared/context/unit-preferences-context";
import LineChart from "../../shared/components/Charts/LineChart";
import Button from "../../shared/components/FormElements/Button";
import { buildChartView, chartCsv, downloadCsv } from "../utils/chartData";

/*
  AssistantChart
  Purpose: a chart inside an Ask Cadenza answer. The values were read from the
  results by Maestro, not written by the model; this converts them to the
  user's units and draws them with the shared LineChart.

  Props:
    - chart: { title, period, dates, series: [{ label, column, unit, values }] }
*/
const AssistantChart = ({ chart }) => {
  const { unitPreferences } = useContext(UnitPreferencesContext);
  const view = useMemo(() => buildChartView(chart, unitPreferences), [chart, unitPreferences]);

  const saveCsv = () => {
    const safeName = chart.title.replace(/[^\w-]+/g, "_").replace(/^_+|_+$/g, "") || "chart";
    downloadCsv(chartCsv(chart, view.series), `${safeName}.csv`);
  };

  return (
    <figure className="ask-cadenza__chart">
      <figcaption>{chart.title}</figcaption>
      <LineChart data={view.data} customOptions={view.options} height="280px" />
      <div className="ask-cadenza__chart-foot">
        <span className="ask-cadenza__muted">
          {chart.period ? `${chart.period[0].toUpperCase()}${chart.period.slice(1)} values, ` : ""}
          read directly from the results
        </span>
        <Button type="button" size="small" inverse onClick={saveCsv}>
          Download CSV
        </Button>
      </div>
    </figure>
  );
};

export default AssistantChart;
